import { render, staticRenderFns } from "./Nations.vue?vue&type=template&id=3896087c&scoped=true&"
import script from "./Nations.vue?vue&type=script&lang=js&"
export * from "./Nations.vue?vue&type=script&lang=js&"
import style0 from "./Nations.vue?vue&type=style&index=0&id=3896087c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896087c",
  null
  
)

component.options.__file = "Nations.vue"
export default component.exports